module.exports = __webpack_public_path__ + "static/lectureLivre-ca640955615ff2d678d25432e9eb541b.png";